import { Box, SxProps, Theme } from '@mui/material';
import vbiLogoWhite from 'assets/images/VBI-Logo-white.png';
import vbiLogoColor from 'assets/images/VBIF-Logo-01.png';

export interface VbiLogoProps {
  variant?: 'color' | 'white';
  sx?: SxProps<Theme>;
  height?: number;
}

export const VbiLogo: React.FC<VbiLogoProps> = ({ variant = 'color', sx, height = 72 }) => {
  return (
    <Box
      component="img"
      src={variant === 'white' ? vbiLogoWhite : vbiLogoColor}
      alt="Virginia Birth-Related Neurological Injury Compensation Program"
      sx={{
        height,
        width: 'auto',
        maxWidth: '100%',
        objectFit: 'contain',
        ...sx,
      }}
    />
  );
};
